import React from 'react';
import { withTheme } from 'styled-components';
import SiteFooter from '@g4/next-furniture/SiteFooter';

import { useSSRQuery } from '../../graphql';
import SITE_FOOTER_QUERY from './wrappedSiteFooter/siteFooter.query.graphql';

const WrappedSiteFooter = () => {
  const { loading, error, data } = useSSRQuery(SITE_FOOTER_QUERY);

  if (loading) {
    return null;
  }

  if (error) {
    throw error;
  }

  return <SiteFooter data={data} />;
};

export default withTheme(WrappedSiteFooter);
